"use strict";
document.addEventListener('DOMContentLoaded', () => {
    const contentLetras = document.querySelector('.content-letras');
    const glosarioList = document.getElementById('glosario-list');
    const urlElement = document.getElementById('url');
    let glosario = [];
    let arrayGlosario = { glosario: [] };
    let tipoText = 'A';
    let letras = [];
    let resultsLetras = [];
    async function loadFilters() {
        const res1 = await fetch('/api/glossary');
        const finalRes1 = await res1.json();
        arrayGlosario['glosario'] = finalRes1;
        setResults(finalRes1.length);
    }
    function getWord() {
        const word = urlElement === null || urlElement === void 0 ? void 0 : urlElement.innerHTML;
        if (word && word !== 'all') {
            const wordElement = document.getElementById(word);
            if (wordElement) {
                wordElement.classList.add('word-item--active');
                getConsonant(word);
                setTimeout(() => {
                    const scrollDiv = wordElement.offsetTop - 120;
                    window.scrollTo({ top: scrollDiv, behavior: 'smooth' });
                }, 500);
            }
        }
    }
    function getConsonant(word) {
        const consonant = word.charAt(0).toUpperCase();
        changeLetra(consonant);
    }
    function setResults(limit) {
        glosario = [];
        letras = [];
        const array = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'Ñ', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'X', 'Y', 'Z'];
        for (let i = 0; i < limit; i++) {
            const name = arrayGlosario['glosario'][i].name;
            const description = arrayGlosario['glosario'][i].description__value;
            const url = arrayGlosario['glosario'][i].field_glossary_source;
            const id = name.split(' (')[0].replace(' ', '-').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
            glosario.push({ nombre: name, id, description: description, url: url });
            const firstLetter = name.slice(0, 1).toUpperCase();
            if (array.includes(firstLetter)) {
                letras.push(firstLetter);
            }
        }
        resultsLetras = Array.from(new Set(letras));
        lettersList();
        populateGlosarioList();
    }
    function lettersList() {
        contentLetras.innerHTML = '';
        resultsLetras.forEach(letter => {
            const li = document.createElement('li');
            li.classList.add('items-letras', 'ev-tabs__item', `letra-${letter}`);
            letter == 'A' ? li.classList.add(`active`) : '';
            li.innerHTML = letter;
            contentLetras.appendChild(li);
        });
    }
    function populateGlosarioList() {
        glosarioList.innerHTML = '';
        glosario.forEach(item => {
            if (item.nombre.slice(0, 1) === tipoText) {
                const div = document.createElement('div');
                div.id = item.id;
                const wordItem = document.createElement('div');
                wordItem.classList.add('word-item');
                const wordLabel = document.createElement('p');
                wordLabel.classList.add('word-item__label');
                wordLabel.innerHTML = `<strong>${item.nombre}</strong>`;
                const wordDefinition = document.createElement('div');
                wordDefinition.classList.add('word-item__definition');
                wordDefinition.innerHTML = item.description;
                wordItem.appendChild(wordLabel);
                wordItem.appendChild(wordDefinition);
                div.appendChild(wordItem);
                glosarioList.appendChild(div);
            }
        });
    }
    function changeLetra(tipo) {
        tipoText = tipo;
        const itemsLetras = document.querySelectorAll('.items-letras');
        itemsLetras.forEach(item => {
            item.classList.remove('active');
        });
        const letraItem = document.querySelector(`.letra-${tipo}`);
        if (letraItem) {
            letraItem.classList.add('active');
        }
        populateGlosarioList();
    }
    contentLetras.addEventListener('click', (event) => {
        const target = event.target;
        if (target && target.classList.contains('items-letras')) {
            const letter = target.textContent || '';
            changeLetra(letter);
        }
    });
    loadFilters();
    setTimeout(getWord, 1000);
});
